import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import JournalsList from "./JournalsList";
import Navbar from "../../components/common/Navbar";
import HeaderBar from "../../components/common/HeaderBar";
import LoaderSpinner from "../../components/common/LoaderSpinner";

import { setLoginHardBlocker } from "../../store/Home/HomeAction";
import {
  getJournalsBySpeakerAction,
  getJournalSpeakersAction,
} from "../../store/Bible/BibleAction";

const AuthorDetails = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { isMobile } = useSelector((state) => state.common);
  const { currentLanguageTitles, languagePreferred } = useSelector(
    (state) => state.languageReducer.data
  );

  const checkToken = localStorage.getItem("token");

  const [popCancle, setPopCancel] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [journals, setJournals] = useState([]);
  const [speakerDetails, setSpeakerDetails] = useState({});

  const handleTabChange = (index) => {
    if (checkToken) {
      setActiveTab(index);
    } else {
      dispatch(setLoginHardBlocker(true));
    }
  };

  const fetchJournals = () => {
    setIsLoading(true);

    dispatch(
      getJournalsBySpeakerAction({
        apiPayloadRequest: { speakerObjId: id },
        callback: (response) => {
          setJournals(response?.data);
          setIsLoading(false);
        },
      })
    );
  };

  const fetchSpeakerDetails = () => {
    dispatch(
      getJournalSpeakersAction({
        apiPayloadRequest: { _id: id },
        callback: (response) => {
          setSpeakerDetails(response?.data?.[0]);
        },
      })
    );
  };

  useEffect(() => {
    fetchJournals();
    fetchSpeakerDetails();
  }, [languagePreferred]);

  return (
    <div className="flex w-full flex-col overflow-hidden md:flex-row">
      <Navbar active={"Journals"} />
      <div className="flex min-h-screen w-full flex-col md:ml-[104px]">
        <HeaderBar
          popCancle={popCancle}
          cancelBtn={!popCancle}
          cancelBtnHandle={() => setPopCancel(true)}
          tabValues={[]}
          stepBack={true}
          back={true}
          backLink="/journals"
          active={activeTab}
          handleTabChange={handleTabChange}
          getLanguagePreferred={() => {}}
          getCurrentLanguageTitles={() => {}}
        />
        <h2 className="bg-black px-5 text-2xl text-white">
          {currentLanguageTitles?.[0]?.bible?.journals_lbl ?? "Journals"} by{" "}
          <span className="font-semibold italic">
            {speakerDetails?.speakerDisplayName}
          </span>
        </h2>
        <div className="flex w-full flex-1 flex-col overflow-y-auto bg-black p-5 md:p-8">
          {isLoading ? (
            <div className="flex h-[60vh] w-full items-center justify-center">
              <LoaderSpinner />
            </div>
          ) : (
            <JournalsList gridItems={isMobile ? 2 : 8} data={journals} />
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthorDetails;
